import { NativeSelect, styled } from "@mui/material";

const GvSelectCustom = styled(NativeSelect)(({ theme }) => ({
  "label + &": {
    marginTop: theme.spacing(3),
  },
  "&.MuiInput-root:before": {
    border: "1px solid transparent",
    height: "100%",
    borderRadius: "0.5rem", // 8px converted to rem
  },
  "&.MuiInput-root:hover:not(.Mui-disabled):before": {
    border: "1px solid transparent",
  },
  "&.MuiInput-root.Mui-focused:not(.Mui-disabled):before": {
    border: `1px solid ${theme.palette.primary.main}`,
  },
  "&.MuiInputBase-root.MuiInput-root:after": {
    border: "none",
  },
  "& .MuiNativeSelect-select": {
    backgroundColor: "#fff",
    fontSize: "0.75rem", // 12px converted to rem
    padding: "0.6875rem 0.75rem", // 11px 12px converted to rem
    borderRadius: "0.5rem", // 8px converted to rem
  },
  "& .MuiNativeSelect-select.MuiInput-input:focus": {
    backgroundColor: "#fff",
  },
  "&.MuiInput-root.Mui-error .MuiNativeSelect-select": {
    backgroundColor: theme.palette.error.light,
    border: `1px solid ${theme.palette.error.main}`,
  },
  "&.Mui-disabled .MuiNativeSelect-select": {
    backgroundColor: theme.palette.sand.main,
    color: theme.palette.gray.dark,
    opacity: 0.7,
    borderRadius: 0,
  },
  "&.Mui-disabled .MuiNativeSelect-icon": {
    color: theme.palette.gray.dark,
  },
}));

export default GvSelectCustom;
